<template>
    <DataTable :loading="!header" :value="dataArray" responsiveLayout="scroll"
        class="p-datatable-sm editable-cells-table" :rowClass="hideRow">
        <Column>
            <template #header="">
                <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm" @click="addDetail"
                    :disabled="!canEdit" />
            </template>
            <template #body="slotProps">
                <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm" @click="deleteDetail(slotProps)"
                    :disabled="!canEdit" />
            </template>
        </Column>
        <Column field="WorkerId" :header="$t('worker')" key="WorkerId">
            <template #body="slotProps">
                <CustomSelect v-model="slotProps.data[slotProps.column.props.field]"
                    :url="$API_URL + 'list/worker_list'" :minLength="0" :filter="true"
                    @change="onCellEditComplete(slotProps); changeWorker(slotProps, $event)"
                    :disabled="!canEdit || slotProps.data.mode != this.$FORM_MODE_CREATE"
                    :params="{ permitId: this.header.Id }" />
            </template>
        </Column>
        <!-- <Column field="PersonnelName" :header="$t('PersonnelName')" key="PersonnelName">
            <template #body="slotProps">
                <InputText name="PersonnelName" v-model="slotProps.data[slotProps.column.props.field]" type="text"
                    :placeholder="$t('PersonnelName')" :disabled="true" @change="onCellEditComplete(slotProps)" />
            </template>
        </Column> -->
        <Column field="TimeIn" :header="$t('time_in')" key="TimeIn">
            <template #body="slotProps">
                <DatePicker id="calendar-timeonly" momentFormat="HH:mm" v-if="header"
                    v-model="slotProps.data[slotProps.column.props.field]" timeOnly
                    :disabled="!canEdit || slotProps.data.mode != this.$FORM_MODE_CREATE"
                    @change="onCellEditComplete(slotProps);" />
            </template>
        </Column>
        <Column field="TimeOut" :header="$t('time_out')" key="TimeOut">
            <template #body="slotProps">
                <DatePicker id="calendar-timeonly" momentFormat="HH:mm" v-if="header"
                    v-model="slotProps.data[slotProps.column.props.field]" timeOnly
                    :disabled="!canEdit || slotProps.data.mode == this.$FORM_MODE_CREATE"
                    @change="onCellEditComplete(slotProps);" />
            </template>
        </Column>
        <Column field="Remark" :header="$t('remark')" key="Remark">
            <template #body="slotProps">
                <InputText name="Remark" v-model="slotProps.data[slotProps.column.props.field]" type="text"
                    :placeholder="$t('remark')" :disabled="mode != this.$FORM_MODE_CREATE &&
        mode != this.$FORM_MODE_EDIT" @change="onCellEditComplete(slotProps)" />
            </template>
        </Column>
    </DataTable>
</template>
<script>
import moment from 'moment';
export default {
    props: {
        dataArray: {
            type: Array,
            default: []
        },
        dataModel: {
            type: Object,
            default: []
        },
        mode: {
            type: String,
            default: ""
        },
        header: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            companyCode: this.$store.getters.getCompanyCode,
            timezoneUserOffset: this.$store.getters.getTimezoneOffset,
        }
    },
    methods: {
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        addDetail() {
            var newDetail = this.dataModel;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.dataArray.push(det);
        },
        deleteDetail(event) {
            if (event) {
                var detail = this.dataArray[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.dataArray.splice(this.dataArray.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditComplete(event) {

            this.editDetail(event.index);
        },
        editDetail(index) {
            if (this.dataArray && this.dataArray.length > 0) {
                let m = this.dataArray[index].mode;

                if (m == this.$FORM_MODE_UNCHANGED) {
                    this.dataArray[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
        changeWorker(event, e) {
            if (this.dataArray && this.dataArray.length > 0) {
                this.dataArray[event.index].WorkerId = e == null ? "" : e.id;
                this.dataArray[event.index].PersonnelName = e == null ? "" : e.name;
            }
        }
    },
    computed: {
        canEdit() {
            return this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT;
        },
        adjustedData() {
            if (this.dataArray != null) {
                return this.dataArray.map(item => ({
                    ...item,
                    TimeIn: item.TimeIn ? moment(item.TimeIn).add(this.timezoneUserOffset, 'hours').format() : null,
                    TimeOut: item.TimeOut ? moment(item.TimeOut).add(this.timezoneUserOffset, 'hours').format() : null,
                }));
            }

        }
    }
}
</script>